import config from './commands/config';

export {default} from './loadConfig';
export {loadConfigAsync} from './loadConfig';

export const commands = [config];
